<template>
  <PapeleriaEnlistmentList/>
</template>
<script>
import PapeleriaEnlistmentList from '@/components/modules/papeleria/enlistment/list'
export default {
  name: 'PapeleriaEnlistment',
  components: {
    PapeleriaEnlistmentList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/enlistment/list.vue